import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ModalState {
    isModalOpen: boolean;
    searchTerm: string;
    shouldCallApi: boolean;
    shouldGoalCallApi: boolean;
    shouldcallTaskApi: boolean;
    shouldReviewApi: boolean;
    shouldDRIPApi: boolean;
    shouldCallTeamTaskApi: boolean;
    shouldCallCAPAApi: boolean;
    shouldCallInboxApi: boolean;
}

const initialState: ModalState = {
    isModalOpen: false,
    searchTerm: "",
    shouldCallApi: false,
    shouldGoalCallApi: false,
    shouldcallTaskApi: false,
    shouldReviewApi: false,
    shouldDRIPApi: false,
    shouldCallTeamTaskApi: false,
    shouldCallCAPAApi: false,
    shouldCallInboxApi: false,
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (state) => {
            state.isModalOpen = true;
        },
        closeModal: (state) => {
            state.isModalOpen = false;
        },
        setSearchTerm: (state, action: PayloadAction<string>) => {
            state.searchTerm = action.payload;
        },
        triggerApiCall: (state) => {
            state.shouldCallApi = true;
        },
        triggerGoalsApi: (state) => {
            state.shouldGoalCallApi = true;
        },
        triggerTaskApi: (state) => {
            state.shouldcallTaskApi = true;
        },
        triggerReviewsApi: (state) => {
            state.shouldReviewApi = true;
        },
        triggerDRIPApi: (state) => {
            state.shouldDRIPApi = true;
        },
        triggerTeamTaskApi: (state) => {
            state.shouldCallTeamTaskApi = true;
        },
        triggerCAPAAPi: (state) => {
            state.shouldCallCAPAApi = true;
        },
        triggerInboxAPi: (state) => {
            state.shouldCallInboxApi = true;
        }
    },
});

export const { openModal, closeModal, setSearchTerm, triggerApiCall, triggerGoalsApi, triggerTaskApi, triggerReviewsApi, triggerDRIPApi, triggerTeamTaskApi, triggerCAPAAPi, triggerInboxAPi } = modalSlice.actions;
export default modalSlice.reducer;